var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboardDoubleArrowLeft = function SvgKeyboardDoubleArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "keyboard_double_arrow_left_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#keyboard_double_arrow_left_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.825 12 3.875 3.9q.275.275.288.688a.93.93 0 0 1-.288.712.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-4.6-4.6a.9.9 0 0 1-.213-.325A1.1 1.1 0 0 1 5.426 12q0-.2.063-.375A.9.9 0 0 1 5.7 11.3l4.6-4.6a.98.98 0 0 1 .688-.287.93.93 0 0 1 .712.287.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7zm6.6 0 3.875 3.9q.276.275.287.688a.93.93 0 0 1-.287.712.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-4.6-4.6a.9.9 0 0 1-.213-.325 1.1 1.1 0 0 1-.062-.375q0-.2.063-.375a.9.9 0 0 1 .212-.325l4.6-4.6a.98.98 0 0 1 .688-.287.93.93 0 0 1 .712.287.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7z"
  }))));
};
export default SvgKeyboardDoubleArrowLeft;